module.exports = __webpack_public_path__ + "img/24.014cfd3e.png";